import React from 'react';
import { Card, CardTag } from '../../../components/common';

/**
 * 客户案例数据接口
 */
export interface CaseStudy {
  id: string;
  title: string;
  description: string;
  appScreenshot: {
    src: string;
    alt: string;
  };
  tags?: string[];
}

/**
 * 客户案例卡片组件属性
 */
interface CaseStudyCardProps {
  caseStudy: CaseStudy;
  className?: string;
}

/**
 * 客户案例卡片组件
 * 左右布局，左侧展示小程序截图，右侧展示介绍内容
 * @param {CaseStudyCardProps} props - 组件属性
 * @returns {JSX.Element} 渲染的React组件
 */
const CaseStudyCard: React.FC<CaseStudyCardProps> = ({ caseStudy, className = '' }) => {
  const { title, description, appScreenshot, tags } = caseStudy;
  
  return (
    <div className={`case-study-card case-study-card scroll-fade-up ${className}`}>
      <Card className="overflow-hidden" padding="none" radius="large">
        <div className="flex flex-col md:flex-row overflow-hidden">
          {/* 左侧小程序截图 */}
          <div className="case-study-image md:w-2/5 relative">
            <div className="phone-mockup scroll-effect scroll-delay-1">
              <img 
                src={appScreenshot.src} 
                alt={appScreenshot.alt} 
                className="w-full h-auto object-cover"
                loading="lazy"
              />
            </div>
          </div>
          
          {/* 右侧介绍内容 */}
          <div className="case-study-content md:w-3/5 p-6 md:p-8 flex flex-col justify-center">
            {tags && tags.length > 0 && (
              <div className="mb-4 flex flex-wrap gap-2">
                {tags.map((tag, index) => (
                  <CardTag 
                    key={index} 
                    text={tag}
                    color="primary"
                  />
                ))}
              </div>
            )}
            
            <h3 className="text-2xl md:text-3xl font-bold text-secondary mb-4">{title}</h3>
            
            <p className="text-gray-600 mb-6">{description}</p>
            
            <div className="mt-auto">
              <button className="inline-flex items-center text-primary font-medium hover:underline">
                查看详情
                <svg className="ml-2 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default CaseStudyCard;